function preventDefault(_target, _propertyKey, descriptor) {
  const originalValue = descriptor.value;
  descriptor.value = function(e) {
    e.preventDefault();
    e.stopPropagation();
    return originalValue.call(this, e);
  };
}
export {
  preventDefault
};
